import IDTFRecordingReviewPane from './IDTFRecordingReviewPane';

export default IDTFRecordingReviewPane;



// WEBPACK FOOTER //
// ./src/views/containers/IDTFRecordingReviewPane/index.js